export const FEATURE_FLAGS = {
	FILE_UPLOAD: "file-upload",
	EDIT_EXPORTED_ENTRIES: "edit-exported-entries",
} as const;

export type FeatureFlagSlug =
	(typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
